import { Breadcrumbs, Divider, Grid, Link, useMediaQuery } from '@mui/material'
import React, { useEffect } from 'react'; 
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom'
import globalStyles from '../../../../assets/styles/global.module.scss';
import GlobalPageHeaderText from '../../../utility/globalPageHeaderText'; 
import styles from "../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import { IntegrationContext, IntegrationContextPayload } from '../../../../context/integrationContext';
import { GenericDataContext, GenericDataContextPayload } from '../../../../context/genericDataContext';
import { accountSetupBreadcrumb, channelsBreadcrumb, homeBreadcrumb } from '../../../../utils/breadcrumb';

const ZohoIntegration = () => { 

    const navigate = useNavigate();
    const { integrationList, zohoIntegrations } = React.useContext(IntegrationContext) as IntegrationContextPayload; 
    const { setBreadCrumbs } = React.useContext(GenericDataContext) as GenericDataContextPayload;

    const [searchParams] = useSearchParams()
    let id = searchParams.get('id')
    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)')
    let pathname = window.location.pathname.toLowerCase();

    const getZohoUserName = () => {
        let zoho_user_name = "Zoho Account"; 
        if(zohoIntegrations){
            let obj = zohoIntegrations?.find((zohoIntegration) => zohoIntegration.zoho_integration_id === Number(id));
            if(obj){
                zoho_user_name = obj.zoho_user_name;
            }
        }
        return zoho_user_name;
    }    

    useEffect(() => {
        const updatedBreadcrumbs = [
            homeBreadcrumb, 
            {...channelsBreadcrumb}, 
            {name: getZohoUserName(), path: `/channels/viewintegration/zoho?id=${id}`, isActive: false, isSamePageRedirecting: pathname === "/channels/viewintegration/zoho"}, 
            {...accountSetupBreadcrumb, isActive: true}
        ];
        setBreadCrumbs(updatedBreadcrumbs);
    }, [id, zohoIntegrations])

  return (
    <>
      <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} 
            ${styles.templateWrapper}
            `}>
                <Grid container sx={{ padding: { xs: "15px 20px 0px 20px", lg: "25px 25px 0px 27px" } }}>
                    <Grid item xs={12}>
                        <Grid container className={globalStyles.createChatbotContainer}>
                            <Grid item xl={6} lg={5} md={9} sm={9} xs={9} sx={{ marginBottom: { xs: "0px", lg: "10px" } }}>
                                <GlobalPageHeaderText
                                    mainHeadText={
                                        pathname === '/channels/viewintegration/integration/templatemessages' && id ? "Template Messages" :
                                            pathname === '/channels/viewintegration/integration/templateinfo' && id ? "Template Info" :
                                                pathname === '/channels/viewintegration/integration/pages' && id ? "Pages" :
                                                    id ? "Account Setup" : "New Account"}
                                    flagMainTextOnly
                                />
                            </Grid>
                            {!smallScreen && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles}`} />}
                            <Outlet />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
    </>
  )
}

export default ZohoIntegration
